var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-6" },
    [
      _c("h2", { staticClass: "text-xl font-semibold mb-4" }, [
        _vm._v("Listado de Permisos"),
      ]),
      _c(
        "div",
        { staticClass: "dis-div" },
        [
          _c(
            "v-row",
            { attrs: { justify: "start" } },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "can",
                      rawName: "v-can",
                      value: "Crear Permisos",
                      expression: "'Crear Permisos'",
                    },
                  ],
                  staticClass: "ml-3 border-button",
                  attrs: { color: "success" },
                  on: {
                    click: function ($event) {
                      _vm.showModal = true
                    },
                  },
                },
                [
                  _vm._v(" Crear Permiso "),
                  _c("v-icon", { staticClass: "ml-2" }, [
                    _vm._v("mdi mdi-plus-box-multiple-outline"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-row",
            { attrs: { justify: "end" } },
            [
              _c("v-text-field", {
                staticClass: "r-search",
                attrs: {
                  "append-icon": "mdi-magnify",
                  "hide-details": "",
                  label: "Buscar permiso",
                  "single-line": "",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-data-table", {
        staticClass: "elevation-1 mt-5",
        attrs: {
          headers: _vm.headers,
          items: _vm.permissions,
          search: _vm.search,
          loading: _vm.loading,
          "loading-text": "Cargando permisos...",
        },
        scopedSlots: _vm._u(
          [
            {
              key: `item.actions`,
              fn: function ({ item }) {
                return [
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text border-button",
                      attrs: { color: "rgb(204 33 40)" },
                      on: {
                        click: function ($event) {
                          return _vm.editPermission(item)
                        },
                      },
                    },
                    [
                      _vm._v(" Editar "),
                      _c("v-icon", { staticClass: "ml-2" }, [
                        _vm._v("mdi-pencil"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "1200px", persistent: "" },
              model: {
                value: _vm.showModal,
                callback: function ($$v) {
                  _vm.showModal = $$v
                },
                expression: "showModal",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline" },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.isEditing ? "Editar Permiso" : "Crear Permiso"
                          ) +
                          " "
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.showModal = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          model: {
                            value: _vm.formValid,
                            callback: function ($$v) {
                              _vm.formValid = $$v
                            },
                            expression: "formValid",
                          },
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Nombre del Permiso",
                              rules: _vm.inputRules,
                              disabled: _vm.isEditing,
                              required: "",
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                          _c("v-text-field", {
                            attrs: {
                              label: "Módulo / Descripción",
                              rules: _vm.inputRules,
                              required: "",
                            },
                            model: {
                              value: _vm.form.description,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "description", $$v)
                              },
                              expression: "form.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { attrs: { justify: "center" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _vm.showAlert
                                ? _c(
                                    "v-alert",
                                    {
                                      staticClass: "my-4",
                                      attrs: {
                                        type: _vm.alertType,
                                        dense: "",
                                        outlined: "",
                                        border: "left",
                                        "colored-border": "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.alertMessage) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "gray", text: "" },
                          on: { click: _vm.closeModal },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticStyle: {
                            "background-color": "rgb(204 33 40)",
                            color: "white !important",
                          },
                          attrs: { disabled: !_vm.formValid },
                          on: { click: _vm.savePermission },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.isEditing ? "Guardar Cambios" : "Crear"
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-overlay",
                    {
                      attrs: {
                        value: _vm.loading,
                        absolute: "",
                        opacity: "0.6",
                      },
                    },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          indeterminate: "",
                          size: "64",
                          color: "rgb(204 33 40)",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }